// get the T-Card policy agree checkbox
const checkbox = document.querySelector('#agree');
// get the pre-order product buttons
const buttons = document.querySelectorAll('.js-popup-cart-button');
buttons.forEach((button) => {
  // Check the box agreeing to the T-Card policy to toggle the attribute.
  if(!checkbox) return;
  checkbox.addEventListener('click', () => {
    button.toggleAttribute('disabled');
  });
});